module.exports = __webpack_public_path__ + "static/media/pie.22726a25.svg";